import { Dropdown, Button } from "antd"
import { useTranslation } from "react-i18next"
import { useState, useEffect } from "react"
import { DownOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import PropTypes from "prop-types"
import { usePermissions } from "hooks/usePermissions"
import { MODULES } from "utils/permissions"

const getContactActions = (t, setType, hasMessagesAccess, hasEmail, hasPhone) => {
  const items = [
    {
      key: "send_email",
      label: t("client.contact.send_email"),
      onClick: () => setType("email"),
      disabled: !hasEmail
    },
    {
      key: "send_message",
      label: t("client.contact.send_message"),
      onClick: () => setType("message"),
      show: hasMessagesAccess
    },
    {
      key: "send_text",
      label: t("client.contact.send_text"),
      onClick: () => setType("text"),
      disabled: !hasPhone
    }
  ]

  return {
    items: items.filter((item) => item.show !== false)
  }
}

const ClientContact = ({ client, bookingUuid, bookingId }) => {
  const { user_id } = client || {}
  const { t } = useTranslation()
  const [type, setType] = useState("")
  const navigate = useNavigate()
  const { hasModuleAccess } = usePermissions()
  const hasMessagesAccess = hasModuleAccess(MODULES.MESSAGES)
  const templatesCollection = client[`${type}_templates_collection`]

  useEffect(() => {
    if (type) {
      const navState = { clients: [client], userIds: [user_id], templates: templatesCollection, bookingUuid, bookingId }
      switch (type) {
        case "email":
          navigate(routes.guideClientEmailActionPath(), { state: navState })
          break
        case "text":
          navigate(routes.guideClientTextActionPath(), { state: navState })
          break
        default:
          navigate(routes.guideClientMessageActionPath(), { state: navState })
      }
    }
    return () => {
      setType("")
    }
  }, [type, client, navigate, user_id, templatesCollection, bookingUuid])

  return (
    <Dropdown
      className={`px-xl py-l`}
      placement="bottomRight"
      trigger={["click"]}
      menu={getContactActions(t, setType, hasMessagesAccess, !!client?.user?.email, !!client?.user?.phone_number)}
      overlayClassName="contactDropdown"
    >
      <Button variant="outlined" color="primary" icon={<DownOutlined />} iconPosition="end">
        {t("global.contact")}
      </Button>
    </Dropdown>
  )
}

ClientContact.propTypes = {
  client: PropTypes.object,
  bookingUuid: PropTypes.string,
  bookingId: PropTypes.number
}

ClientContact.defaultProps = {
  client: {}
}

export default ClientContact
